/*
PURPOSE: Editorial FAQ section for the home page — the "STRAIGHT ANSWERS" beat.
USE CASES:
- Final content section of the home page, after Impact.
DOMAIN BOUNDARIES:
- Thin composition of editorial primitives + the SAME faqData module and the
  SAME shared FAQItem component the legacy Home uses (expand/collapse and
  FAQ_ITEM_VIEWED analytics preserved verbatim). Copy comes verbatim from
  useCopy().publicPages.home.support.
- FAQItem hardcodes white text for the legacy dark theme and is shared with
  legacy Home, so it is NOT modified here. Its question/answer colours are
  re-themed for the cream surface via scoped important-variant overrides on
  the wrapper only — legacy Home stays pixel-identical.
- No imports from design-sandbox/.
*/

import React from 'react';
import { useCopy } from '../../../hooks/useCopy';
import { EditorialSection, Eyebrow, DisplayHeading } from '../../../components/editorial';
import FAQItem from '../../../components/FAQItem/faqItem';
import { faqData } from '../../../copy/faqData';

const Faq: React.FC = () => {
  const copy = useCopy();
  const { sectionTitle, faqDescription } = copy.publicPages.home.support;

  return (
    <EditorialSection background="cream" id="faq">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16">
        <div>
          <Eyebrow>{sectionTitle}</Eyebrow>
          <DisplayHeading as="h2" scale="heading" className="mt-8">
            {faqDescription}
          </DisplayHeading>
        </div>
        <div className="space-y-2 [&_button_span]:!text-editorial-ink [&_button+div]:!text-editorial-muted/80">
          {faqData.map((faq, index) => (
            <FAQItem key={index} question={faq.question} answer={faq.answer} />
          ))}
        </div>
      </div>
    </EditorialSection>
  );
};

export default Faq;
